import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon55: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 16.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 16 20" width={width} height={height} {...props}>
      <Path
        d="M8.53802 0.0256021C11.358 0.294602 13.5 2.8046 13.5 5.7146V9.99859H13.991C15.05 9.99859 15.918 10.8176 15.994 11.8576L16 12.0066V16.0256C16 18.2206 14.221 19.9986 12.027 19.9986H3.97302C1.77902 19.9986 0 18.2206 0 16.0256V12.0066C0 10.8976 0.899972 9.99859 2.00897 9.99859H2.5V5.4996C2.5 2.2606 5.28403 -0.284398 8.53802 0.0256021ZM13.991 10.9986H2.00897C1.45197 10.9986 1 11.4506 1 12.0066V16.0256C1 17.6676 2.33102 18.9986 3.97302 18.9986H12.027C13.669 18.9986 15 17.6676 15 16.0256V12.0066C15 11.4506 14.548 10.9986 13.991 10.9986ZM8.5 14.9966C8.776 14.9966 9 15.2206 9 15.4966C9 15.7726 8.776 15.9966 8.5 15.9966H7.5C7.224 15.9966 7 15.7726 7 15.4966C7 15.2206 7.224 14.9966 7.5 14.9966H8.5ZM5.5 14.9966C5.776 14.9966 6 15.2206 6 15.4966C6 15.7726 5.776 15.9966 5.5 15.9966H4.5C4.224 15.9966 4 15.7726 4 15.4966C4 15.2206 4.224 14.9966 4.5 14.9966H5.5ZM11.5 14.9966C11.776 14.9966 12 15.2206 12 15.4966C12 15.7726 11.776 15.9966 11.5 15.9966H10.5C10.224 15.9966 10 15.7726 10 15.4966C10 15.2206 10.224 14.9966 10.5 14.9966H11.5ZM3.5 5.4996V9.99859H4.5V5.49359C4.5 3.62559 5.96398 2.0986 7.80798 1.9996L8 1.99359C9.933 1.99359 11.5 3.56059 11.5 5.49359V9.99859H12.5V5.7146C12.5 3.3796 10.841 1.36459 8.651 1.04559L8.44397 1.0206C5.77697 0.766597 3.5 2.8496 3.5 5.4996ZM8 2.99359C6.619 2.99359 5.5 4.11259 5.5 5.49359V9.99859H10.5V5.49359C10.5 4.16859 9.469 3.0836 8.164 2.9996L8 2.99359Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
